module.exports = __webpack_public_path__ + "static/media/Palermo.9f586b97.png";